import * as React from 'react';
import Carousel from '../common/Carousel';
import './RecentOrderCarouselContainer.scss';

interface IRecentOrderCarouselContainerProps {
  loading: boolean;
  children: any;
}

export function RecentOrderCarouselContainer(
  props: IRecentOrderCarouselContainerProps
) {
  return (
    <div className="rp-carousel-container">
      {props.loading ? (
        <div className="loader-container">
          <div className="loader" />
        </div>
      ) : (
        <Carousel
          responsive={{
            560: {
              items: 2,
              showArrows: true,
              singleitemPercentage: 50,
              mobileException: true
            },
            950: {
              items: 2,
              showArrows: true,
              singleitemPercentage: 50,
              mobileException: false
            },
            1270: {
              items: 3,
              showArrows: true,
              singleitemPercentage: 33,
              mobileException: false
            },
            1300: {
              items: 4,
              showArrows: true,
              singleitemPercentage: 25,
              mobileException: false
            },
            2000: {
              items: 4,
              showArrows: true,
              singleitemPercentage: 25,
              mobileException: false
            },
            3000: {
              items: 4,
              showArrows: true,
              singleitemPercentage: 25,
              mobileException: false
            }
          }}
        >
          {props.children}
        </Carousel>
      )}
    </div>
  );
}
